// Auth store — manages login/logout state across the app.
// Uses Redux Toolkit createSlice (replaces manual action creators + combineReducers).
// State shape is preserved: state.login.currentStatus.status (boolean)

import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'login',
    initialState: {
        currentStatus: { status: false },
    },
    reducers: {
        // addLog(true) = logged in, addLog(false) = logged out
        addLog(state, action) {
            state.currentStatus.status = action.payload;
        },
    },
});

export const { addLog } = authSlice.actions;
export default authSlice.reducer;